import React, { useState } from "react";

import "./stylesKeyFeatures.css";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
} from "chart.js";
import { AppStrings } from "../../../../utils/constants/AppStrings";

const {
  KEY_FEATURES_LABLE_1,
  KEY_FEATURES_LABLE_2,
  KEY_FEATURES_LABLE_3,
  KEY_FEATURES_LABLE_4,
} = AppStrings;

function KeyFeatures() {
  const [activeIndex, setActiveIndex] = useState(0);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
  );

  const data = {
    labels: [
      KEY_FEATURES_LABLE_1,
      KEY_FEATURES_LABLE_2,
      KEY_FEATURES_LABLE_3,
      KEY_FEATURES_LABLE_4
    ],
    datasets: [
      {
        data: [10455, 7453, 5758, 3699, 2455],
        backgroundColor: ["#1ABC9C"],
        borderColor: ["#1ABC9C"],
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    scales: {
      x: {
        beginAtZero: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        anchor: "end",
        align: "start",
        formatter: (value) => value.toLocaleString(),
        color: "black",
        font: {
          family: "Poppins-regular",
          weight: "bold",
        },
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        backgroundColor: "#252729",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
      },
    },
  };
  return (
    <div id="platform-overview-chart">
      <div className="platform-overview-chart-header">
        <h3>{AppStrings.KEY_FEATURES_USAGE}</h3>
      </div>
      <div className="platform-overview-chart-body">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
}

export default KeyFeatures;
